module.exports = __webpack_public_path__ + "img/pro-sem.8a6d2089.png";